import { render } from "./ActiveOrders.vue?vue&type=template&id=55279feb"
import script from "./ActiveOrders.vue?vue&type=script&lang=js"
export * from "./ActiveOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/orders/ActiveOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55279feb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55279feb', __exports__)) {
    console.log('reload')
    api.reload('55279feb', __exports__)
  }
  
  module.hot.accept("./ActiveOrders.vue?vue&type=template&id=55279feb", () => {
    console.log('re-render')
    api.rerender('55279feb', render)
  })

}


export default __exports__